import { render, staticRenderFns } from "./CompanyInformationTab.vue?vue&type=template&id=386235bd&"
import script from "./CompanyInformationTab.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CompanyInformationTab.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports